import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import Listing from 'components/Listing'
import { EventContext } from 'context/EventContext'
import { getImpressionStatus } from 'helpers/eventHelpers'
import useImpressionsObserver from 'helpers/useImpressionsObserver'
import useViewport from 'hooks/useViewport'

import DesktopContent from './components/DesktopContent'
import MobileContent from './components/MobileContent'

import classes from './AlternativeCard.module.scss'

const OBSERVER_OPTIONS = {
  rootMargin: '0px 0px 0px 0px',
  threshold: 1.0,
}

/** @type {import('./types').default} */
const AlternativeCard = ({ alternative, listing, index }) => {
  const { ref, addEvent } = useImpressionsObserver(OBSERVER_OPTIONS)
  const { between, down } = useViewport()
  const onlySaveIcon = between('sm', 'md')

  return (
    <Listing.Card className={clsx('ListingCard', classes.root)}>
      <div
        ref={ref}
        {...addEvent({
          name: 'product_impression',
          productImpressionUuid: alternative.global_product_id,
          engagementDestination: 'alternative_impression',
          engagementComponent: 'product_card-item',
          engagementDetails: 'alternative-product_list_section',
          productImpressionPosition: index,
          criteriaId: '',
          criteriaVersion: '',
          productImpressionStatus: getImpressionStatus(alternative.is_premium),
        })}
      />
      <EventContext
        value={{
          engagementComponent: 'product_card-item',
          name: 'engagement_product_card',
          productImpressionPosition: index,
          productImpressionUuid: alternative.global_product_id,
        }}
      >
        <div className={classes.headerWrapper}>
          <Listing.Header listing={alternative} listingPosition={index} enableBuyerIntent>
            <Listing.Buttons.Main
              listingPosition={index}
              className={classes.mainButton}
              listing={alternative}
              enableBuyerIntent
              endIcon={alternative.is_premium && <Icon icon={['far', 'external-link']} size="16" />}
            />
            <Listing.Buttons.CompareSave
              listing={alternative}
              onlySaveIcon={onlySaveIcon}
              className={classes.compareSave}
            />
          </Listing.Header>
        </div>
        {down('xs') ? (
          <MobileContent listing={listing} alternative={alternative} />
        ) : (
          <DesktopContent listing={listing} alternative={alternative} />
        )}
      </EventContext>
    </Listing.Card>
  )
}

export default AlternativeCard
